import axios from 'axios';

export default {
    namespaced: true,

    state: {
        enterableTournamentsByName: [],
        enterableTournamentsByDeadline: [],
        enterableTournamentsByNameRePair: [],

        loadingEnterableTournamentsByName: false,
        loadingEnterableTournamentsByDeadline: false,
        loadingEnterableTournamentsByNameRePair: false,

        loadingErrorEnterableTournamentsByName: null,
        loadingErrorEnterableTournamentsByDeadline: null,
        loadingErrorEnterableTournamentsByNameRePair: null,
    },

    getters: {
        enterableTournamentsByName: (state) => state.enterableTournamentsByName,
        enterableTournamentsByDeadline: (state) => state.enterableTournamentsByDeadline,
        enterableTournamentsByNameRePair: (state) => state.enterableTournamentsByNameRePair,

        loadingEnterableTournamentsByName: (state) => state.loadingEnterableTournamentsByName,
        loadingEnterableTournamentsByDeadline: (state) => state.loadingEnterableTournamentsByDeadline,
        loadingEnterableTournamentsByNameRePair: (state) => state.loadingEnterableTournamentsByNameRePair,

        loadingErrorEnterableTournamentsByName: (state) => state.loadingErrorEnterableTournamentsByName,
        loadingErrorEnterableTournamentsByDeadline: (state) => state.loadingErrorEnterableTournamentsByDeadline,
        loadingErrorEnterableTournamentsByNameRePair: (state) => state.loadingErrorEnterableTournamentsByNameRePair,
    },

    mutations: {
        setEnterableTournamentsByName(state, data) { state.enterableTournamentsByName = data },
        setEnterableTournamentsByDeadline(state, data) { state.enterableTournamentsByDeadline = data },
        setEnterableTournamentsByNameRePair(state, data) { state.enterableTournamentsByNameRePair = data },

        startLoadingEnterableTournamentsByName(state) { state.loadingEnterableTournamentsByName = true; },
        startLoadingnterablesTournamentsByDeadline(state) { state.loadingEnterableTournamentsByDeadline = true; },
        startLoadinEgnterablesTournamentsByNameRePair(state) { state.loadingEnterableTournamentsByNameRePair = true; },

        stopLoadingEnterableTournamentsByName(state) { state.loadingEnterableTournamentsByName = false; },
        stopLoadingnterablesTournamentsByDeadline(state) { state.loadingEnterableTournamentsByDeadline = false; },
        stopLoadingEnterableTournamentsByNameRePair(state) { state.loadingEnterableTournamentsByNameRePair = false; },

        setLoadingErrorEnterableTournamentsByName(state, error) { state.loadingErrorEnterableTournamentsByName = error; },
        setLoadingErrorEnterableTournamentsByDeadline(state, error) { state.loadingError = error; },
        setLoadingErrorEnterableTournamentsByNameRePair(state, error) { state.loadingError = error; },

        clearLoadingErrorEnterableTournamentsByName(state) { state.loadingErrorEnterableTournamentsByName = null; },
        clearLoadingErrorEnterableTournamentsByDeadline(state) { state.loadingError = null; },
        clearLoadingErrorEnterableTournamentsByNameRePair(state) { state.loadingError = null; },

    },

    actions: {
        async getEnterableTournamentsByName(context) {
            context.commit('startLoadingEnterableTournamentsByName');
            context.commit('clearLoadingErrorEnterableTournamentsByName');
            try {
                var result = await axios.get(`${HOST_NAME}/api/DoublesEntry/EnterableTournaments`);
                context.commit('setEnterableTournamentsByName', result.data);
                context.commit('stopLoadingEnterableTournamentsByName');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingErrorEnterableTournamentsByName', error);
                context.commit('stopLoadingEnterableTournamentsByName');
                return Promise.reject(error);
            }
        },

        async getEnterableTournamentsByDeadline(context) {
            context.commit('startLoadingnterablesTournamentsByDeadline');
            context.commit('clearLoadingErrorEnterableTournamentsByDeadline');
            try {
                var result = await axios.get(`${HOST_NAME}/api/DoublesEntry/EnterableTournamentsByDeadline`);
                context.commit('setEnterableTournamentsByDeadline', result.data);
                context.commit('stopLoadingnterablesTournamentsByDeadline');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingErrorEnterableTournamentsByDeadline', error);
                context.commit('stopLoadingnterablesTournamentsByDeadline');
                return Promise.reject(error);
            }
        },

        async getEnterableTournamentsByNameRePair(context, options = {}) {
            context.commit('startLoadinEgnterablesTournamentsByNameRePair');
            context.commit('clearLoadingErrorEnterableTournamentsByNameRePair');
            try {
                var result = await axios.get(`${HOST_NAME}/api/DoublesEntry/EnterableTournamentsNamesRepair/${options.playerNbr}`);
                context.commit('setEnterableTournamentsByNameRePair', result.data);
                context.commit('stopLoadingEnterableTournamentsByNameRePair');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingErrorEnterableTournamentsByNameRePair', error);
                context.commit('stopLoadingEnterableTournamentsByNameRePair');
                return Promise.reject(error);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/doubles/enterable-drop-downs.js